export default __webpack_public_path__ + "static/Workflow-automation-f923cbc035e771dd335bdccbfbd1a445.webp";